import {
  AppBar,
  Badge,
  Box,
  Button,
  CardMedia,
  Checkbox,
  Collapse,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogProps,
  DialogTitle,
  Divider,
  Drawer,
  FormControlLabel,
  FormGroup,
  Grid,
  IconButton,
  Input,
  InputAdornment,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  MenuProps,
  Select,
  Stack,
  Theme,
  Typography,
  useTheme,
} from '@mui/material';
import FormControl from '@mui/material/FormControl';
import React, {
  Fragment,
  MutableRefObject,
  useEffect,
  useState,
} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { matchPath, useLocation } from 'react-router';
import { Link as RouterLink } from 'react-router-dom';
import { logout } from '../redux-store/actions/auth';
import { ProfileIcon } from './customSVGs';
// import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import { ArrowDropDown, Close, MoreVert, Search } from '@mui/icons-material';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Formik, useFormikContext } from '../lib/formik/Formik';
import { useHistory } from 'react-router';
import * as yup from 'yup';
import { MFTextField } from '../lib/formik';
import MFCheckbox from '../lib/formik/Checkbox';
import { SearchFieldWrapper, renderFilteredOptions } from '../lib/formik/searchSelectField';
import { RootStateType } from '../redux-store/reducers';
import { Applicant } from '../redux-store/types/api-types';
import { APPLICATION_TYPE, USER_ROLES } from '../utils/constant';
import { copyGraphToClipboard, getAbbreviatedCharactors, getCountryCodes, isModuleAllowed } from '../utils/utilityFunctions';
import { Item, ItemDetails } from './ApplicationDetails';
import { KeyValue } from './ApplicationDetails/personalDetails';
import { SubHeading } from './investors/components';
import { useSnackbar } from 'notistack';
import { SET_VALUE } from '../redux-store/types/valueConverter';
import DropdownIcon from '../assets/icons/DropdownIcon';
import { CartIcon, HamburgerCLIcon, WarningIcon } from '../assets/SvgIcons';
import dayjs from '../utils/dayjs';
import getSideBarData from './sideBarData';
import { visuallyHidden } from '@mui/utils';
const OTP_TIMER_ANNOUNCEMENT_CHECKPOINTS = [60, 50, 40, 30, 15, 10, 5];

export function OtpTimer({ onResend }: { onResend: () => void }): JSX.Element {
  const [counter, setCounter] = useState(60);
  const [liveMessage, setLiveMessage] = useState<string>('');

  // Third Attempts
  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const timer: any = counter > 0 && setInterval(() => setCounter(counter - 1), 1000);
    return () => clearInterval(timer);
  }, [counter]);

  useEffect(() => {
    if (counter === 0) {
      setLiveMessage('You can now resend OTP.');
      return;
    }
    if (OTP_TIMER_ANNOUNCEMENT_CHECKPOINTS.includes(counter)) {
      setLiveMessage(`Resend OTP available in ${counter} seconds.`);
    }
  }, [counter]);

  return (
    <Grid container justifyContent="center" rowSpacing={0.5}>
      <Box
        component="span"
        role="status"
        aria-live="polite"
        aria-atomic="true"
        sx={visuallyHidden}
      >
        {liveMessage}
      </Box>
      <Grid item xs={12} textAlign="center">
        <Typography variant='body_400' color="textDark.secondary">
          Didn’t receive OTP?{' '}
          <Typography
            component="button"
            type="button"
            variant='body_400'
            sx={{
              background: 'none',
              border: 'none',
              padding: 0,
              font: 'inherit',
              cursor: counter > 0 ? "not-allowed" : "pointer"
            }}
            color={counter > 0 ? "textDark.secondary" : "primary.800"}
            onClick={() => {
              try {
                if (counter === 0) {
                  onResend();
                  setCounter(60);
                }
              } catch (e) {
                console.error((e as Error).message);
              }
            }}
          >
            Resend OTP
          </Typography>
        </Typography>
      </Grid>
      <Grid item xs={12} textAlign="center">
        {counter > 0 && <Typography variant='body_400' color="textDark.secondary" aria-hidden="true">in {counter} seconds</Typography>}
      </Grid>
    </Grid >
  );
}

// Footer
export const Footer = (): JSX.Element => {
  return (
    <Box
      component="footer"
      sx={(theme: Theme) => ({
        bgcolor: theme.palette.customColors.darkGrey,
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        justifyContent: 'center',
        py: 1,
      })}>
      <Typography sx={{ color: 'text.primary', width: 'unset', mr: '0.5rem' }}>
        Powered By{' '}
      </Typography>
      <CardMedia
        component="img"
        src="/images/kfin-new-logo.png"
        alt="kFintech Logo"
        sx={{ width: 'unset', objectFit: 'contain', height: 'fit-content' }}
      />
    </Box>
  );
};
// Footer End

// Login Layout
export const LoginLayout = ({
  LoginText,
  children,
  renderChildUI
}: {
  LoginText: string;
  children: JSX.Element;
  renderChildUI?: boolean;
}): JSX.Element => {
  const history = useHistory();
  return (
    <Stack
      sx={(theme: Theme) => ({
        minHeight: '100vh',
        background: `${theme.palette.background.default} url("/images/login-bg.svg")`,
        backgroundSize: 'cover',
      })}>
      <AppBar elevation={0} position="static" sx={{ bgcolor: 'transparent' }}>
        <Box>
          <Box
            onClick={() => history.push("/")}
            sx={{
              width: "12rem",
              height: "60px",
              margin: "30px 0px 0px 15px",
              cursor: 'pointer',
              backgroundImage: 'url("/images/nexedge_logo_dark.png")',
              backgroundSize: 'contain',
              backgroundRepeat: 'no-repeat',
              backgroundPosition: 'center',
            }}
            role="link"
            aria-label="Nexedge Logo  Go to home page"
            tabIndex={0}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                history.push("/");
              }
            }}
          />
        </Box>
      </AppBar>
      <Box
        component="main"
        sx={{
          flex: 1,
          display: 'grid',
          placeItems: 'center',
        }}>
        {renderChildUI && (
          <>
            {children}
          </>
        )}
        {!renderChildUI && (
          <Box
            sx={(theme: Theme) => ({
              bgcolor: theme.palette.customColors.darkGrey,
              height: { xs: 'unset', sm: 'unset' },
              width: 'clamp(300px, 70%, 500px)',
              px: { xs: '25px', sm: '80px' },
              py: '50px',
              mb: 2,
              borderRadius: '10px',
            })}>
            {LoginText && (
              <Typography
                component="h1"
                variant="h1"
                sx={{
                  color: 'primary.main',
                  mb: '50px',
                  textAlign: 'center',
                }}>
                {LoginText}
              </Typography>
            )}
            {children}
          </Box>
        )}
      </Box>
      <Footer />
    </Stack>
  );
};
// Login Layout End

// Header & Sidenav
const drawerWidth = '16.87rem';

const MenuButton = ({
  isActive = false,
  to = null,
  text,
  onClick,
}: {
  isActive?: boolean;
  to?: string | null;
  text?: string;
  children?: JSX.Element;
  downArrow?: boolean;
  onClick?: () => void;
}) => {
  const disabled = to === null;
  return (
    <ListItemButton
      onClick={onClick}
      component={disabled ? Typography : RouterLink}
      to={to || ''}
      sx={{
        p: { xs: '10px 20px', md: '12px 15px' },
        background: isActive ? 'rgba(30, 144, 255, 1)' : 'transparent',
        color: isActive ? 'rgba(237, 242, 247, 1)' : 'secondary.main',
        stroke: isActive ? '#2057A6' : '#131836',
        strokeWidth: 0,
        height: '54px',
        '.MuiSvgIcon-root ': {
          opacity: isActive ? 1 : 0.5,
        },
        textAlign: 'center',
        borderRadius: '15px',
      }}>
      <Typography
        sx={{ color: isActive ? 'rgba(237, 242, 247, 1)' : 'text.primary', fontWeight: '600' }}
        variant="subtitle_400">
        {text}
      </Typography>
    </ListItemButton>
  );
};

const dashboardLinks = [
  { label: 'Home', link: '/dashboard' },
  { label: 'Clients', link: '/investors' },
  { label: 'Net Sales', link: '/net-sales' },
  { label: 'Total RMs', link: '/total-rm-detail' },
];

const productsLinks = [
  { label: 'Mutual Funds', link: '/product' },
  { label: 'Direct Equity', link: '/product/direct-equity' },
  { label: 'PMS', link: '/product/pms' },
  { label: 'Debt', link: '/product/debt' },
  { label: 'Alternates', link: '/product/alternates' },
];

const analyticsLinks = [
  { label: 'Mutual Fund Research', link: '/analytics/mutual-fund-research' },
  { label: 'Portfolio Analytics', link: '/analytics/portfolio-analytics' },
  { label: 'Revenue Analytics', link: '/analytics/revenue-analytics' },
];

const applicationLinks = [
  { label: 'Add New', link: '/onboarding' },
  { label: 'View Existing', link: '/applications' },
  { label: 'View Email Consent', link: '/view-consent-email-list' },
  // { label: 'Onboarding DashBoard', link: '/onboard-overview' },

]

const ordersLinks = [
  { label: 'Order Dashboard', link: '/orders/order-dashboard' },
  { label: 'Order Entry', link: '/orders/order-entry' }
]

export const FilterDrawer = ({
  selectedFilters,
  setSelectedFilters,
  ...rest
}: MenuProps & {
  selectedFilters: {
    [key: string]: string[];
  };
  setSelectedFilters: React.Dispatch<React.SetStateAction<{ [key: string]: string[] }>>;
}): JSX.Element => {
  const [selectedFilterSection, setSelectedFilterSection] = useState<number | string>(-1);
  const [selectedLocalFilters, setSelectedLocalFilters] = useState<{ [key: string]: string[] }>(
    selectedFilters
  );
  const [search, setSearch] = useState<string>('');
  const { filters: totalFilters } = useSelector((state: RootStateType) => state.products);
  const filters = totalFilters
    .filter((each) => {
      const children = each.options.filter((option) => {
        return option && typeof option === 'object'
          ? option.label.toLowerCase().includes(search.toLowerCase())
          : option && option.toLowerCase().includes(search.toLowerCase());
      });
      return children.length > 0;
    })
    .map((each) => {
      return {
        ...each,
        options: each.options.filter((option) =>
          option && typeof option === 'object'
            ? option.label.toLowerCase().includes(search.toLowerCase())
            : option && option.toLowerCase().includes(search.toLowerCase())
        ),
      };
    });

  useEffect(() => {
    setSelectedLocalFilters(selectedFilters);
  }, [selectedFilters]);
  return (
    <Menu
      {...rest}
      transformOrigin={{ horizontal: 'center', vertical: 'top' }}
      PaperProps={{ sx: { maxWidth: '400px' } }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%', p: 2, gap: 4 }}>
        <Input
          placeholder="Search"
          fullWidth
          endAdornment={<Search />}
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
        <IconButton onClick={(e) => rest?.onClose && rest?.onClose(e, 'backdropClick')} aria-label="Close">
          <Close />
        </IconButton>
      </Box>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3, p: 2 }}>
        {filters.map(
          (
            {
              title,
              key,
              options,
            }: {
              title: string;
              key: string;
              options: ({ label: string; value: string } | string)[];
            },
            index: number
          ) => (
            <Box key={`${title}_${index}`} sx={{ width: '100%' }}>
              <Box>
                <Box
                  onClick={() => {
                    setSelectedFilterSection(selectedFilterSection === key ? -1 : key);
                  }}
                  sx={{
                    width: '100%',
                    gap: 3,
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                    cursor: 'pointer',
                  }}>
                  <Typography>{title}</Typography>
                  <ArrowDropDown sx={{ color: '#337FC9' }} />
                </Box>
                <Divider />
              </Box>
              {selectedFilterSection === key && (
                <Box
                  sx={{
                    pt: 1,
                    px: 2,
                    maxHeight: '150px',
                    transition: '0.3s all',
                    overflow: 'auto',
                  }}>
                  <FormGroup>
                    {options.map(
                      (option: { label: string; value: string } | string, index: number) => {
                        let label = '',
                          value = '';
                        if (option && typeof option === 'object') {
                          label = option.label;
                          value = option.value;
                        } else if (option) {
                          label = option;
                          value = option;
                        }

                        return label && value ? (
                          <Fragment key={`${value}_${index}`}>
                            <FormControlLabel
                              control={
                                <Checkbox
                                  checked={
                                    selectedLocalFilters?.[key]
                                      ? selectedLocalFilters?.[key].includes(value)
                                      : false
                                  }
                                  onChange={(e) => {
                                    const updatedFilters = { ...selectedLocalFilters };
                                    const { checked } = e.target;
                                    if (updatedFilters[key]) {
                                      if (checked) {
                                        const values = [...updatedFilters[key]];
                                        if (!values.includes(value)) {
                                          values.push(value);
                                        }
                                        updatedFilters[key] = values;
                                      } else {
                                        updatedFilters[key] = updatedFilters[key].filter(
                                          (val) => val !== value
                                        );
                                      }
                                    } else if (checked) {
                                      updatedFilters[key] = [value];
                                    }
                                    setSelectedLocalFilters(updatedFilters);
                                  }}
                                  checkedIcon={
                                    <Box
                                      sx={{
                                        border: '2px solid #22242C',
                                        margin: '2px',
                                        borderRadius: '2px',
                                        backgroundColor: '#337FC9',
                                        '&:before': {
                                          display: 'block',
                                          width: 16,
                                          height: 16,
                                          content: '""',
                                        },
                                      }}></Box>
                                  }
                                />
                              }
                              label={label}
                            />
                            <Divider />
                          </Fragment>
                        ) : null;
                      }
                    )}
                  </FormGroup>
                </Box>
              )}
            </Box>
          )
        )}
        <Box sx={{ display: 'flex', flexDirection: 'row', gap: 3 }}>
          <Button
            onClick={(e) => {
              setSelectedFilters(selectedLocalFilters);
              rest?.onClose && rest?.onClose(e, 'backdropClick');
            }}
            sx={{
              bgcolor: '#337FC9',
              borderRadius: '5px',
              fontWeight: 'normal',
              padding: 0,
              px: 1,
              '&:hover': { bgcolor: '#2868a6' },
            }}>
            Apply
          </Button>
          <Button
            onClick={(e) => {
              setSelectedFilters({});
              rest?.onClose && rest?.onClose(e, 'backdropClick');
            }}
            sx={{
              border: '1px solid #337FC9',
              borderRadius: '5px',
              padding: 0,
              px: 1,
              color: 'primary.500',
              fontWeight: 'normal',
              '&:hover': {
                bgcolor: '#eaf0f5',
              },
            }}>
            Clear All
          </Button>
        </Box>
      </Box>
    </Menu>
  );
};

export const Header = ({ handleDrawerOpen }: { handleDrawerOpen: () => void }): JSX.Element => {
  const theme = useTheme();
  const { role, permissions = [] } = useSelector((store: RootStateType) => store.auth);
  const { cartItemsCount = 0 } = useSelector((store: RootStateType) => store.cart);
  const { rmName = "", businessDate = "", company = "", environment = "", userRole = "" } = useSelector((store: RootStateType) => store.navbarInfo);

  const formattedBusinessDate = businessDate ? dayjs(businessDate, 'DD/MM/YYYY').format('DD MMM, YYYY') : ""

  const dispatch = useDispatch();
  const [menuAnchorEl, setMenuAnchorEl] = useState<null | HTMLElement>(null);
  const [isLogout, setIsLogout] = useState<boolean>(false);
  const menuOpen = Boolean(menuAnchorEl);
  const { palette } = useTheme();

  const history = useHistory()

  const handleProfileLogout = async () => {
    setIsLogout(true);
    await dispatch(logout());
    setIsLogout(false)
  }

  const handleCartIconClick = () => {
    if (location.pathname !== '/cart') {
      history.push("/cart")
    }
  }

  return (
    <>
      <Box
        sx={(theme: Theme) => ({
          display: 'flex',
          justifyContent: { xs: 'space-between' },
          alignItems: 'center',
          padding: { xs: '25px 20px 20px' },
          mb: { xs: '15px' },
          backgroundColor: { xs: theme.palette.customColors.infoCard },
          [theme.breakpoints.up(1400)]: {
            backgroundColor: theme.palette.background.default,
            justifyContent: 'flex-end',
            padding: '20px 25px 0px 25px'
          },
        })}>
        <Box sx={{
          display: { xs: 'flex', },
          [theme.breakpoints.up(1400)]: {
            display: "none"
          },
          alignItems: 'center',
          columnGap: '0.6rem',
        }}>
          <IconButton
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerOpen}
            sx={(theme: Theme) => ({
              // display: { md: 'none' },
              [theme.breakpoints.up(1400)]: {
                display: "none"
              },
              color: 'text.primary'
            })}>
            <HamburgerCLIcon />
          </IconButton>
          <Box
            onClick={() => history.push("/")}
            sx={{
              width: "12rem",
              height: "60px",
              cursor: 'pointer',
              backgroundImage: 'url("/images/nexedge_logo_dark.png")',
              backgroundSize: 'contain',
              backgroundRepeat: 'no-repeat',
              backgroundPosition: 'center',
              'aria-hidden': 'true',
              role: 'presentation',
            }}
            role="link"
            aria-label="Go to home page"
            tabIndex={0}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                history.push("/");
              }
            }}
          />
        </Box>
        <Box
          sx={{
            display: { xs: "none", sm: "flex", md: "flex", lg: "flex" },
            columnGap: "1.5rem"
          }}
        >
          {(rmName || formattedBusinessDate || company) && (
            <Box
              sx={(theme: Theme) => ({
                display: "flex",
                columnGap: "1rem",
                alignItems: "center",
                boxShadow: `0px 4px 10px 0px ${theme.palette.common.black}0D`,
                padding: '5px',
                backgroundColor: theme.palette.customColors.darkGrey
              })}
            >
              {rmName && (
                <Typography
                  variant='body_600'
                  sx={(theme: Theme) => ({ color: theme.palette.primary[800] })}
                >
                  {`${rmName} (${userRole})`}
                </Typography>

              )}
              {formattedBusinessDate && (
                <Typography
                  variant='body_600'
                  sx={(theme: Theme) => ({ color: theme.palette.primary[800] })}
                >
                  System Date: {formattedBusinessDate}
                </Typography>
              )}
              {company && (
                <Typography
                  variant='body_600'
                  sx={(theme: Theme) => ({ color: theme.palette.primary[800] })}
                >
                  Company: {company}
                </Typography>
              )}

              {environment && (
                <Typography
                  variant='body_600'
                  sx={(theme: Theme) => ({ color: theme.palette.primary[800] })}
                >
                  Environment: {environment}
                </Typography>
              )}
            </Box>
          )}

          <Box sx={{
            display: { xs: 'flex' },
            alignItems: 'center',
          }}>
            {(
              [USER_ROLES.INVESTOR].includes(role) &&
              isModuleAllowed({ value: "MFOrders", compareArr: permissions, objKey: "permissonCode" })
            ) && (
                <IconButton
                  onClick={handleCartIconClick}
                  aria-label={`${cartItemsCount} cart items`}
                  role='button'
                >
                  <Badge
                    invisible={cartItemsCount === 0}
                    badgeContent={cartItemsCount}
                    sx={(theme: Theme) => ({
                      '& .MuiBadge-badge': {
                        right: 5,
                        top: 10,
                        backgroundColor: theme.palette.primary[500],
                        color: theme.palette.customColors.darkGrey,
                        ...theme.typography.subtitle_600
                      },
                    })}
                  >
                    <CartIcon />
                  </Badge>
                </IconButton>
              )}
            <IconButton
              sx={{ padding: 0, ml: 1.5, backgroundColor: theme.palette.customColors.darkGrey }}
              onClick={(e) => setMenuAnchorEl(e.currentTarget)}
              aria-label="Profile"
              role='button'
            >
              <ProfileIcon />
            </IconButton>

          </Box>
        </Box>

      </Box >

      <Menu
        anchorEl={menuAnchorEl}
        open={menuOpen}
        onClose={() => setMenuAnchorEl(null)}
        MenuListProps={{
          'aria-labelledby': 'logout-button',
          sx: {
            padding: "8px 0px",

          }
        }}
        slotProps={{
          paper: {
            style: {
              width: '200px',
              borderRadius: "12px",
              backgroundColor: palette.common.white,
            }
          }
        }}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}

      >
        <MenuItem
          onClick={() => {
            handleProfileLogout()
          }}
          disabled={isLogout}
          aria-label="Logout"
          role='button'
        >
          {isLogout ? 'Logging out...' : 'Logout'}
        </MenuItem>
      </Menu >

    </>
  );
};

export const ConfirmationDialog = ({
  open,
  setOpen,
  message = 'Are you sure you want to delete?',
  subMessage = "",
  onCancel,
  onSave,
  showIcon = false,
  icon,
  primaryButtonText = 'Yes',
  secondaryButtonText = "No"
}: {
  message: string;
  subMessage?: string;
  open: boolean;
  setOpen: () => void;
  onCancel: () => void;
  onSave: () => void;
  showIcon?: boolean;
  icon?: JSX.Element;
  primaryButtonText?: string;
  secondaryButtonText?: string
}): JSX.Element => {
  return (
    <Dialog
      onClose={setOpen}
      open={open}
      maxWidth='sm'
      fullWidth
      role="alertdialog"
      aria-labelledby="confirmation-dialog-title"
      aria-describedby={subMessage ? "confirmation-dialog-desc" : undefined}
      sx={{
        '& .MuiPaper-root': {
          borderRadius: '15px',
          backgroundColor: "background.paper",
          rowGap: "25px",
        },
      }}
    >
      <DialogContent sx={{ paddingTop: "25px" }}>
        <Box sx={{ display: "flex", columnGap: "8px" }}>
          {showIcon ? icon || <WarningIcon /> : null}
          <Typography
            id="confirmation-dialog-title"
            variant='h2'
            color="text.primary"
            mb="10px"
          >
            {message}
          </Typography>
        </Box>
        {subMessage &&
          <Typography
            id="confirmation-dialog-desc"
            variant='subtitle_400'
            color="text.secondary"
            sx={{
              lineHeight: "20px"
            }}
          >
            {subMessage}
          </Typography>
        }
      </DialogContent>
      <DialogActions sx={{ padding: "25px", columnGap: "10px" }}>
        <Button
          variant="outlined"
          onClick={onCancel}
          sx={(theme: Theme) => ({
            color: theme.palette.text.secondary,
            flex: 1,
            border: `0.5px solid ${theme.palette.text.secondary}`,
            padding: "10px",
            "&:hover, &.Mui-focusVisible": {
              borderColor: theme.palette.text.secondary,
              backgroundColor: theme.palette.background.default
            }
          })}
        >
          {secondaryButtonText}
        </Button>
        <Button
          variant="contained"
          sx={(theme: Theme) => ({
            flex: 1,
            color: theme.palette.textDark.primary,
            padding: "10px"
          })}
          onClick={onSave}
        >
          {primaryButtonText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

type Props = DialogProps & {
  title?: string;
  content: string;
  actions: {
    label: string;
    onClick: () => void;
  }[];
};

export default function SimpleDialog({ title, ...props }: Props): JSX.Element {
  const theme = useTheme()

  return (
    <Dialog
      role="alertdialog"
      aria-labelledby={title ? 'simple-dialog-title' : 'simple-dialog-message'}
      aria-describedby={props.content ? 'simple-dialog-message' : 'simple-message'}
      {...props}
      sx={{
        '& .MuiPaper-root': {
          minWidth: { sx: '300px', md: '400px' },
          maxWidth: { sx: '500px', md: '500px' },
          borderRadius: '8px',
          padding: '30px 30px 20px',
          textAlign: 'center',
          color: '#4f4f4f',
          '&:focus': {
            outline: '2px solid',
            outlineColor: 'primary.500',
            outlineOffset: '2px',
          },
        },
        '& .MuiDialogContent-root': {
          textAlign: 'center',
          '& .MuiDialogContentText-root': {
            color: theme.palette.text.primary
          }
        },
        '& .MuiDialogActions-root': {
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          '& .MuiButton-root': {
            width: '160px',
            height: '58px',
            borderRadius: '8px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '18px',
            margin: 'auto',
            marginBottom: '20px',
            '&:focus': {
              outline: '2px solid',
              outlineColor: 'primary.500',
              outlineOffset: '2px',
            },
          },
        },
      }}>
      {title && <DialogTitle id="simple-dialog-title">{title}</DialogTitle>}
      <DialogContent>
        <DialogContentText id="simple-dialog-message" variant="h2">{props.content}</DialogContentText>
      </DialogContent>
      <DialogActions>
        {props.actions.map((action, index) => (
          <Button variant="contained" color="primary" key={index} onClick={action.onClick}>
            {action.label}
          </Button>
        ))}
      </DialogActions>
    </Dialog>
  );
}

export function CountryCodesDropDown({
  name,
  value,
  readOnly = false,
  disabled = false,
  ElementWidth,
}: {
  name: string;
  value: string;
  readOnly?: boolean;
  disabled?: boolean;
  ElementWidth?: number | null;
}): JSX.Element {
  const { setFieldValue } = useFormikContext();
  const [query, setQuery] = useState('');

  const theme = useTheme()

  return (
    <InputAdornment
      position="start"
      sx={{
        pr: '0 !important',
        mx: '0 !important',
      }}>
      <Box
        sx={{
          '.MuiOutlinedInput-root': {
            marginTop: '0',
            '&.MuiInputBase-root': {
              '& .MuiSelect-select': {
                padding: '0',
                border: 'none',
                '& .MuiBox-root': {
                  columnGap: "5px",
                  alignItems: "center"
                }
              },
            },
            '.MuiOutlinedInput-notchedOutline': {
              border: 'none',
            },
            '&.Mui-focused': {
              border: `2px solid ${theme.palette.primary.main}`,
            },
          },

          '&.Mui-focused,&:hover': {
            '.MuiOutlinedInput-notchedOutline': {
              borderWidth: 'none',
            },
          },
        }}
      >
        <Select
          name={name}
          inputProps={{ 'aria-label': 'Country code' }}
          onChange={(e) => {
            setFieldValue(name, `${e.target.value}`);
          }}
          value={value}
          renderValue={(value) => {
            return (
              <Box sx={{ pr: "15px", mr: "15px", display: "flex", justifyContent: "center", borderRightWidth: "1.3px", borderRightStyle: "solid", borderRightColor: "text.secondary" }}>
                <Typography component="span" variant='body_500' color="text.primary">{value.split(':')[1] ? value.split(':')[1].trim() : value}</Typography>
                <DropdownIcon strokeColor={theme.palette.text.secondary} />
              </Box>
            );
          }}
          IconComponent={() => null}
          MenuProps={{
            transformOrigin: {
              vertical: 'top',
              horizontal: 'left',
            },
            anchorOrigin: { vertical: 'bottom', horizontal: 'left' },
            sx: {
              '.MuiPaper-root ': {
                width: 'fit-content',
                ml: '-10px',
                maxHeight: '20%',
                overflowX: 'auto',
              },
            },
            disableAutoFocusItem: true,
            MenuListProps: {
              disableListWrap: true,
            },
          }}
          onClose={() => {
            setQuery('');
          }}
          readOnly={readOnly}
          disabled={disabled}
        >
          <SearchFieldWrapper searchFieldPlaceholder={'Search Country Code...'} setQuery={setQuery} />
          {renderFilteredOptions(
            getCountryCodes().map((codes) => ({
              key: codes.label,
              value: codes.label,
            })),
            query
          )}
        </Select>
      </Box>
    </InputAdornment >
  );
}
export interface AmlPopupValues {
  amlComments: string;
  amlAcknowledgement: boolean;
}

const amlPopupInitialValues: AmlPopupValues = {
  amlComments: '',
  amlAcknowledgement: false,
};
const amlPopupValidation = yup.object().shape({
  amlComments: yup.string().required('Field is required'),
  amlAcknowledgement: yup.bool().test('amlAcknowledgement', 'Field is required', (value) => {
    return value || false;
  }),
});
export function AmlPopup({
  handleClose,
  amlPopupOpen,
  onSubmit,
  FURTHER_INFORMATION,
  EXTERNAL_SOURCES,
  displayDocInfo = false,
}: {
  handleClose: () => void;
  amlPopupOpen: boolean;
  onSubmit: (values: AmlPopupValues) => void;
  FURTHER_INFORMATION?: string;
  EXTERNAL_SOURCES?: string;
  displayDocInfo?: boolean;
}): JSX.Element {
  return (
    <Dialog
      onClose={handleClose}
      open={amlPopupOpen}
      sx={{
        '.MuiPaper-root ': {
          p: 2,
          width: { xs: '100%', sm: '70%' },
        },
      }}>
      <Box sx={{ mb: 2, mt: 1 }}>
        <CardMedia
          component="img"
          src="/images/warning-icon-red.svg"
          sx={{ width: '50px', mx: 'auto' }}
        />
      </Box>
      <Box
        sx={{
          width: { xs: '100%', sm: '89%' },
          mx: 'auto',
        }}>
        <Typography
          sx={{
            color: '#BD2932',
            textAlign: 'center',
            mb: 1,
            fontSize: 14,
            fontWeight: 500,
          }}>
          Sorry, this PAN has failed the AML check
        </Typography>
        <Typography
          sx={{
            color: 'secondary.main',
            textAlign: 'start',
            mt: 2,
            fontSize: 16,
            fontWeight: 500,
            mb: 0.5,
          }}>
          Further Information:
        </Typography>
        <Box
          sx={{
            width: '100%',
            height: '25vh',
            overflowY: 'auto',
            overflowWrap: 'anywhere',
            border: '1px solid #ccc',
            borderRadius: '5px',
          }}>
          <Typography
            sx={{
              color: 'text.primary',
              textAlign: 'start',
              m: 2,
              fontSize: 14,
              fontWeight: 500,
            }}>
            {FURTHER_INFORMATION || ''}
          </Typography>
          <Typography
            sx={{
              color: 'primary.main',
              textAlign: 'start',
              ml: 2,
              fontSize: 16,
              fontWeight: 600,
            }}>
            Reference Links
          </Typography>
          <Typography
            sx={{
              color: 'rgb(0, 0, 255)',
              textAlign: 'start',
              fontSize: 14,
              fontWeight: 500,
              m: 2,
              mt: 0.5,
            }}>
            {EXTERNAL_SOURCES || ''}
          </Typography>
        </Box>
        <Typography
          sx={{
            color: 'secondary.main',
            textAlign: 'start',
            fontSize: 14,
            fontWeight: 500,
            mt: 3,
            mb: 0,
          }}>
          If you still wish to proceed with this PAN, please provide reason below.
        </Typography>
        <Formik
          initialValues={amlPopupInitialValues}
          onSubmit={onSubmit}
          validationSchema={amlPopupValidation}>
          {({ handleSubmit, values }) => (
            <Box
              component="form"
              noValidate
              onSubmit={handleSubmit}
              sx={{
                fontSize: 14,
                fontWeight: 500,
                color: 'text.primary',
                '.MuiTypography-root': {
                  fontSize: 15,
                  fontWeight: 500,
                },
              }}>
              <MFTextField
                name="amlComments"
                multiline
                rows={3}
                inputProps={{
                  maxLength: 1024,
                }}
                placeholder="Type here..."
                displayCharecterCounter={'1024'}
                sx={{
                  color: 'text.primary',
                  pl: 0.5,
                  pt: 0.5,
                  '&.MuiInputBase-root': {
                    fontSize: 14,
                    fontWeight: 500,
                  },
                }}
              />
              <MFCheckbox
                name={`amlAcknowledgement`}
                label="I understand the risks and acknowledge to proceed further."
                sx={{ mt: 1 }}
              />
              {values.amlAcknowledgement && displayDocInfo && (
                <Typography
                  sx={{
                    color: 'primary.main',
                    textAlign: 'center',
                    fontSize: 14,
                    fontWeight: 500,
                    mt: 1,
                    mb: 0,
                  }}>
                  Please upload compliance document in document details.
                </Typography>
              )}
              <Grid container sx={{ mt: 3, mb: 1, justifyContent: 'center', gap: 1.5 }}>
                <Button
                  onClick={() => {
                    handleClose();
                  }}
                  variant="outlined"
                  sx={{
                    fontSize: 15,
                    color: 'primary.main',
                    minWidth: 180,
                    letterSpacing: 2,
                    fontWeight: 500,
                  }}>
                  Cancel
                </Button>
                <Button
                  variant="contained"
                  sx={{
                    fontSize: 15,
                    minWidth: 180,
                    letterSpacing: 2,
                    fontWeight: 400,
                  }}
                  type="submit">
                  Proceed
                </Button>
              </Grid>
            </Box>
          )}
        </Formik>
      </Box>
    </Dialog>
  );
}
export function AmlDetailsFields({
  amlCheck,
  amlCommentedRole,
  amlComments,
}: {
  amlCheck: boolean | undefined;
  amlCommentedRole: string | undefined;
  amlComments: string | undefined;
}): JSX.Element {
  return (
    <Grid
      item
      container
      rowSpacing={3}
      pb={2}
      columnSpacing={13}
      direction="row"
      justifyContent="space-between"
      alignItems="flex-start"
      sx={{ paddingLeft: { xs: 0, sm: '10%' } }}>
      <KeyValue title={'Aml Check'} description={amlCheck?.toString().toUpperCase() || ''} />
      <KeyValue title={'Commented By'} description={amlCommentedRole?.toUpperCase() || ''} />
      <Grid item xs={12}>
        <Item>{'Comments'}</Item>
        <ItemDetails> {amlComments || '-'}</ItemDetails>
      </Grid>
    </Grid>
  );
}
export function AmlDetails({
  applicants = [],
  applicationType,
}: {
  applicants: Partial<Applicant>[];
  applicationType: string;
}): JSX.Element {
  const theme = useTheme()
  return (
    <>
      {!applicants.every((applicant) => applicant.amlCheck) && (
        <Box
          sx={{
            bgcolor: theme.palette.customColors.infoCard,
            boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.05)',
            borderRadius: '10px',
          }}
          my={5}>
          <Box sx={{ p: 2 }}>
            <Grid container sx={{ mt: 1, pl: { xs: 2, sm: 10 }, pr: { xs: 2, sm: 10 } }}>
              <Grid
                container
                direction="row"
                justifyContent="space-between"
                alignItems="flex-start">
                <Typography sx={{ fontSize: 18, fontWeight: 600, color: 'primary.main' }}>
                  Aml Check Details
                </Typography>
              </Grid>
              {applicants
                .filter((applicant) => !applicant.amlCheck)
                .map((applicant, index: number) => {
                  const title = [
                    'First Applicant Details',
                    'Second Applicant Details',
                    'Third Applicant Details',
                  ][Number(applicant.applicant_type) - 1];
                  return (
                    <React.Fragment key={applicant.id}>
                      {applicationType !== APPLICATION_TYPE.NON_INDIVIDUAL && (
                        <SubHeading
                          sx={{
                            color: 'text.primary',
                            letterSpacing: 0.5 + 'px',
                            padding: { xs: '10px 10px', sm: '10px 30px' },
                          }}>
                          {title}
                        </SubHeading>
                      )}
                      <AmlDetailsFields
                        amlCheck={applicant.amlCheck}
                        amlCommentedRole={applicant.amlCommentedRole}
                        amlComments={applicant.amlComments}
                      />
                    </React.Fragment>
                  );
                })}
            </Grid>
          </Box>
        </Box>
      )}
    </>
  );
}

export const LoadingDialog = ({
  loadingPopup,
  onLoadingPopupClose,
  loaderText = 'Loading',
}: {
  loadingPopup: boolean;
  onLoadingPopupClose: () => void;
  loaderText?: string;
}): JSX.Element => {
  return (
    <Dialog
      onClose={onLoadingPopupClose}
      open={loadingPopup}
      sx={{
        '.MuiPaper-root ': {
          p: 4,
          width: { xs: '70%', sm: '70%' },
        },
      }}>
      <Box
        sx={{
          width: { xs: '100%', sm: '80%' },
          mx: 'auto',
          '.MuiTypography-root': {
            fontSize: 20,
            fontWeight: 500,
          },
        }}>
        <Typography sx={{ color: 'primary.main', lineHeight: '35px', textAlign: 'center' }}>
          {loaderText}...
        </Typography>
      </Box>
    </Dialog>
  );
};
export const CopyGraphDropdown = ({
  elementRef,
}: {
  elementRef: React.MutableRefObject<HTMLElement | null>;
}): JSX.Element => {
  const [menuAnchorEl, setMenuAnchorEl] = useState<null | HTMLElement>(null);
  const { enqueueSnackbar } = useSnackbar();
  const menuOpen = Boolean(menuAnchorEl);

  const handleClose = () => setMenuAnchorEl(null);
  return (
    <>
      <IconButton onClick={(e) => setMenuAnchorEl(e.currentTarget)}>
        <MoreVert />
      </IconButton>

      <Menu
        anchorEl={menuAnchorEl}
        transformOrigin={{ horizontal: 'center', vertical: 'top' }}
        open={menuOpen}
        onClose={() => setMenuAnchorEl(null)}
        PaperProps={{ sx: { '.MuiList-root': { padding: 0 } } }}>
        <MenuItem
          onClick={() => {
            handleClose();
            elementRef !== null &&
              copyGraphToClipboard(elementRef as MutableRefObject<HTMLElement>)
                .then(() => {
                  enqueueSnackbar('Graph copied to clipboard successfully.', {
                    variant: 'success',
                    autoHideDuration: 3000,
                  });
                })
                .catch(() => {
                  enqueueSnackbar('Error while copying the graph.', {
                    variant: 'error',
                    autoHideDuration: 3000,
                  });
                });
          }}
          sx={{ padding: '10px 20px' }}>
          Copy
        </MenuItem>
      </Menu>
    </>
  );
};

export function PopoverValue({
  label,
  color,
  amount,
  percent,
}: {
  label?: string | null;
  color: string;
  amount?: string | number | null;
  percent?: string | number | null;
}): JSX.Element {
  return (
    <Grid container>
      <Grid item container alignItems={'center'} justifyContent={'center'}>
        <Grid item xs="auto">
          <Typography
            sx={{
              width: '11px',
              height: '11px',
              borderRadius: '50%',
              background: color,
              display: 'inline-block',
              mr: 1,
            }}></Typography>
        </Grid>
        <Grid item xs>
          <Typography sx={{ fontSize: 13, color: '#22242C', opacity: 0.6, mb: 0.5 }}>
            {label}
          </Typography>
        </Grid>
      </Grid>
      <Grid item container>
        <Grid item xs="auto">
          <Typography
            sx={{
              visibility: 'hidden',
              width: '11px',
              height: '11px',
              borderRadius: '50%',
              background: color,
              display: 'inline-block',
              mr: 1,
            }}></Typography>
        </Grid>
        <Grid item xs>
          <Typography
            sx={{
              fontSize: 13,
              color: '#22242C',
              fontWeight: 500,
            }}>
            {amount}
          </Typography>
        </Grid>
        <Grid item xs="auto">
          <Typography component="span" sx={{ fontSize: 12, fontWeight: 400, color: '#22242C' }}>
            {percent ? `${percent}%` : null}
          </Typography>
        </Grid>
      </Grid>
    </Grid>
  );
}

export const AmountUnit = () => {
  const myState = useSelector((state: any) => state.valueConverter);
  const dispatch = useDispatch();

  const handleChange = (event: any) => {
    dispatch({ type: SET_VALUE, value: event.target.value });
  };

  return (
    <>
      <FormControl>
        <Select
          style={{ color: 'var(--title-color)', height: '1.7rem', width: '7rem' }}
          value={myState}
          onChange={handleChange}
          displayEmpty
          inputProps={{ 'aria-label': 'Without label' }}
          variant="standard"
          sx={{
            fontSize: 12,
            lineHeight: '16px',
            color: '#4E5056',
            fontWeight: 500,
            boxShadow: '1px 1px 3px rgba(0, 0, 0, 0.15)',
            borderRadius: '5px',
            pl: 1,
            background: ' #FFFFFF',
          }}>
          <MenuItem value={0} style={{ color: 'var(--title-color)' }}>
            Numbers
          </MenuItem>
          <MenuItem value={1} style={{ color: 'var(--title-color)' }}>
            Crores
          </MenuItem>
          <MenuItem value={2} style={{ color: 'var(--title-color)' }}>
            Lakhs
          </MenuItem>
        </Select>
      </FormControl>
    </>
  );
};

export function YearSelecter(props: any) {
  return (
    <div
      style={{
        cursor: 'pointer',
        flexGrow: 1,
        flexBasis: 0,
        paddingRight: !props.marginH ? props.marginH : 3,
        paddingLeft: !props.marginH ? props.marginH : 3,
        marginLeft: 2,
        marginRight: 2,
        // marginLeft: !!props.marginH ? props.marginH : 3,
        // marginRight: !!props.marginH ? props.marginH : 3,
        borderRadius: 5,
        paddingTop: !props.paddingV ? props.paddingV : 3,
        paddingBottom: !props.paddingV ? props.paddingV : 3,
        backgroundColor: props.isSelected ? '#337FC9' : 'transparent',
        border: '1px solid #163869',
      }}
      onClick={props.onPress}>
      <div>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            color: props.isSelected ? '#FFFFFF' : '#5A7C82',
            alignItems: 'center',
          }}>
          {props.text}
        </div>
      </div>
    </div>
  );
}

export function TopHoldingButtons(props: any) {
  return (
    <div
      style={{
        display: 'flex',
        margin: 10,
        marginBottom: 15,
        borderRadius: 18,
        border:
          // props.selected === props.label
          '1px solid #00A4A4',
        backgroundColor: props.selected === props.label ? '#337FC9' : '#FFFFFF',
        color: props.selected === props.label ? '#FFFFFF' : '#337FC9',
        flexGrow: 1,
        flexBasis: 0,
        padding: 6,
        alignItems: 'center',
        justifyContent: 'space-between',
        cursor: 'pointer',
      }}
      onClick={props.onPress}>
      <div style={{ fontSize: 14, fontWeight: 500 }}>{props.label}</div>
      <div style={{ fontSize: 14, paddingTop: 5 }}>{props.percentage}%</div>
    </div>
  );
}

function CommonLayoutDrawer({ handleMobileDrawerClose }: { handleMobileDrawerClose: () => void; }) {
  const history = useHistory();

  const [activeCategory, setActiveCategory] = useState<string>("")

  const { pathname } = useLocation();

  const isRouteActive = (routes: string[] | undefined): boolean =>
    (routes ?? []).some((route) => !!matchPath(pathname, { path: route, exact: true }));

  const categoryMap = {
    products: [
      "/product/mutual-fund",
      "/product/direct-equity",
      "/product/pms",
      "/product/debt",
      "/product/alternates",
    ],
    applications: [
      "/onboarding/enter-pan-number",
      "/kyc-applications",
      "/applications",
      "/view-consent-email-list",
      "/applications-list",
      "/compliance-approval",
      "/compliance-application-details/:id"
    ],
    reports: [
      '/reports-download/mf-client-statement',
      '/reports-download/mf-transaction-wise-holding-report',
      '/reports-download/holding-report',
      '/reports-download/capital-gain-statement',
      '/reports-download/transaction-history-report',
      // '/reports-download/ria-report',
      '/reports-download/corporate-action-report',
      "/reports",
    ],
    analytics: [
      "/analytics/mutual-fund-research",
      "/analytics/portfolio-analytics",
      "/analytics/revenue-analytics",
    ],
    orders: [
      "/orders/order-dashboard",
      "/orders/order-entry",
      "/orders-approval"
    ],
    invest: [
      "/investor-dashboard/mutual-fund",
      "/investor-dashboard/direct-equity",
      "/investor-dashboard/pms",
      "/investor-dashboard/debt",
      "/investor-dashboard/alternates",
    ],
    others: [
      "/investor-reports/client-statement",
      "/investor-reports/mf-transaction-wise-holding-report",
      "/investor-reports/holding-report",
      "/investor-reports/transaction-history-report",
      "/investor-reports/capital-gain-statement",
      // "/investor-reports/ria-report",
      "/investor-reports/corporate-action-report"
    ],
    payments: [
      "/payments-approval"
    ],
    banks: [
      '/bank/updateBank',
      '/bank/viewBank'
    ],
    nominee: [
      '/nominee/updateNominee'
    ],
    riaFee: [
      '/ria-report',
      '/ria-dashboard',
      '/ria-fee-setup',
      '/ria-fee-setup/:familyId/modify',
      '/ria-fee-setup/history',
      '/ria-summary',
      '/security-exclusion-management',
      '/security-exclusion-management/audit-history'
    ]
  };

  useEffect(() => {
    const activeCategory = Object.entries(categoryMap).find(([_, paths]) =>
      isRouteActive(paths ?? [])
    )?.[0] || "";

    setActiveCategory(activeCategory);

  }, [pathname])

  const handleLogoClick = () => {
    history.push('/')
  }

  const sideBarItemsArr = getSideBarData({
    activeCategory,
    setActiveCategory
  })

  return (
    <Box>
      <Box
        onClick={handleLogoClick}
        sx={{
          width: "12rem",
          height: "60px",
          margin: "35px 15px 25px 30px",
          cursor: 'pointer',
          backgroundImage: 'url("/images/nexedge_logo_dark.png")',
          backgroundSize: 'contain',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center',
          'aria-hidden': 'true',
          role: 'presentation',
        }}
        role="img"
        aria-label="Go to home page"
        tabIndex={0}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            history.push("/");
          }
        }}
      />
      <List
        role="list"
        sx={{
          ml: '1.5rem',
          mr: '1.5rem',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        {sideBarItemsArr
          .filter(obj => !(obj.isSubMenuItem && !obj?.subMenuItem?.length))
          .map((sideBarItem, index) => {

            if (sideBarItem.isSubMenuItem) {
              const isExpanded = activeCategory === sideBarItem.menuItem.dropdownId;
              const submenuId = `sidebar-submenu-${sideBarItem.menuItem.dropdownId}`;
              return (
                <Box
                  component="li"
                  role="listitem"
                  key={index}
                  sx={{ listStyle: 'none' }}
                >
                  <ListItemButton
                    disableRipple
                    aria-expanded={isExpanded}
                    aria-controls={submenuId}
                    onClick={(e) => {
                      if (sideBarItem.menuItem.isDisabled) {
                        e.preventDefault();
                        return;
                      }
                      sideBarItem.menuItem.handleClick();
                    }}
                    sx={{
                      marginTop: `${index !== 0 ? "8px" : "0px"}`,
                      marginBottom: `${!isExpanded ? "8px" : "0px"}`,
                      padding: "10px",
                      borderRadius: '12px',
                      "&.Mui-disabled": {
                        pointerEvents: "auto",
                        cursor: "not-allowed",
                      },
                      "&:hover": {
                        backgroundColor: "transparent",
                      },
                      "&.Mui-focusVisible, &:focus-visible": {
                        outline: 'none',
                        backgroundColor: 'transparent',
                        boxShadow: 'none',
                      },
                      "&:focus": {
                        outline: 'none',
                      },
                    }}
                    disabled={sideBarItem.menuItem.isDisabled}
                  >
                    <ListItemText
                      sx={(theme: Theme) => ({
                        ".MuiTypography-root": {
                          // ...theme.typography.subtitle_500,
                          fontSize: { xs: "12px", md: "14px", xl: "16px" },
                          fontWeight: '600',
                          color: theme.palette.text.primary
                        }
                      })}
                      primary={sideBarItem.menuItem.name}
                    />
                    {
                      isExpanded ?
                        <ExpandLessIcon aria-hidden="true" sx={{ color: 'text.primary' }} /> :
                        <ExpandMoreIcon aria-hidden="true" sx={{ color: 'text.primary' }} />
                    }
                  </ListItemButton>
                  <Collapse
                    in={isExpanded}
                    timeout={0}
                  >
                    <Box
                      component="ul"
                      id={submenuId}
                      role="list"
                      sx={{
                        listStyle: 'none',
                        m: 0,
                        p: 0,
                      }}
                    >
                      {sideBarItem.subMenuItem.map(dropdownItem => (
                        <Box
                          component="li"
                          role="listitem"
                          key={dropdownItem.name}
                          sx={{ listStyle: 'none' }}
                        >
                          <ListItemButton
                            disableRipple
                            aria-current={isRouteActive(dropdownItem?.route ?? []) ? 'page' : undefined}
                            sx={(theme: Theme) => {
                              const isActive = isRouteActive(dropdownItem?.route ?? [])
                              const hoverBg = dropdownItem.isDisabled
                                ? 'transparent'
                                : isActive
                                  ? theme.palette.primary[500]
                                  : theme.palette.grey[100];
                              return {
                                columnGap: "15px",
                                borderRadius: '15px',
                                padding: "10px",
                                backgroundColor: isActive ? theme.palette.primary[500] : theme.palette.common.white,
                                transition: 'background-color 120ms ease, box-shadow 120ms ease',
                                "&.Mui-disabled": {
                                  pointerEvents: "auto",
                                  cursor: "not-allowed",
                                },
                                '&:hover': {
                                  backgroundColor: hoverBg,
                                },
                                '&:focus': {
                                  outline: 'none',
                                },
                                '&.Mui-focusVisible, &:focus-visible': {
                                  outline: 'none',
                                  backgroundColor: hoverBg,
                                  boxShadow: dropdownItem.isDisabled
                                    ? 'none'
                                    : `0 0 0 2px ${theme.palette.primary[100]}`,
                                },
                              };
                            }}
                            onClick={(e) => {
                              if (dropdownItem.isDisabled) {
                                e.preventDefault();
                                return;
                              }
                              handleMobileDrawerClose()
                              dropdownItem.handleClick();
                            }}
                            disabled={dropdownItem.isDisabled}
                          >
                            <ListItemIcon sx={{ minWidth: "0px" }}>
                              {isRouteActive(dropdownItem?.route ?? []) ? dropdownItem.activeIcon : dropdownItem.inActiveIcon}
                            </ListItemIcon >
                            <ListItemText
                              sx={(theme: Theme) => ({
                                ".MuiTypography-root": {
                                  // ...theme.typography.subtitle_500,
                                  fontSize: { xs: "12px", md: "14px", xl: "16px" },
                                  fontWeight: 500,
                                  color: isRouteActive(dropdownItem?.route ?? []) ? theme.palette.common.white : theme.palette.text.secondary,
                                }
                              })}
                              primary={dropdownItem.name}
                            />
                          </ListItemButton >
                        </Box >
                      ))
                      }
                    </Box >
                  </Collapse >
                </Box >
              )
            } else {
              return (
                <Box
                  component="li"
                  role="listitem"
                  key={index}
                  sx={{ listStyle: 'none' }}
                >
                  <ListItemButton
                    disableRipple
                    aria-current={isRouteActive(sideBarItem?.menuItem?.route ?? []) ? 'page' : undefined}
                    sx={(theme: Theme) => {
                      const isActive = isRouteActive(sideBarItem?.menuItem?.route ?? [])
                      const hoverBg = sideBarItem.menuItem.isDisabled
                        ? 'transparent'
                        : isActive
                          ? theme.palette.primary[500]
                          : theme.palette.grey[100];
                      return {
                        marginTop: `${index !== 0 ? "8px" : "0px"}`,
                        marginBottom: "8px",
                        columnGap: "15px",
                        borderRadius: '15px',
                        padding: "10px",
                        backgroundColor: isActive ? theme.palette.primary[500] : theme.palette.common.white,
                        transition: 'background-color 120ms ease, box-shadow 120ms ease',
                        "&.Mui-disabled": {
                          pointerEvents: "auto",
                          cursor: "not-allowed",
                        },
                        '&:hover': {
                          backgroundColor: hoverBg,
                        },
                        '&:focus': {
                          outline: 'none',
                        },
                        '&.Mui-focusVisible, &:focus-visible': {
                          outline: 'none',
                          backgroundColor: hoverBg,
                          boxShadow: sideBarItem.menuItem.isDisabled
                            ? 'none'
                            : `0 0 0 2px ${theme.palette.primary[100]}`,
                        },
                      };
                    }}
                    onClick={(e) => {
                      if (sideBarItem.menuItem.isDisabled) {
                        e.preventDefault();
                        return;
                      }
                      sideBarItem.menuItem.handleClick();
                    }}
                    disabled={sideBarItem.menuItem.isDisabled}
                  >
                    <ListItemIcon
                      sx={{ minWidth: "0px" }}
                    >
                      {isRouteActive(sideBarItem?.menuItem?.route ?? []) ? sideBarItem.menuItem.activeIcon : sideBarItem.menuItem.inActiveIcon}
                    </ListItemIcon >
                    <ListItemText
                      primary={sideBarItem.menuItem.name}
                      sx={(theme: Theme) => ({
                        ".MuiTypography-root": {
                          // ...theme.typography.subtitle_500,
                          fontSize: { xs: "12px", md: "14px", xl: "16px" },
                          fontWeight: 500,
                          color: isRouteActive(sideBarItem?.menuItem?.route ?? []) ? theme.palette.text.primary : theme.palette.text.secondary,
                        }
                      })}
                    />
                  </ListItemButton >
                </Box >
              )
            }
          })}
      </List >
    </Box >
  );
};

export function CommonLayoutSidenav({
  isMobileDrawerOpen,
  handleMobileDrawerClose,
}: {
  isMobileDrawerOpen: boolean;
  handleMobileDrawerClose: () => void;
}): JSX.Element {

  return (
    <Box
      component="nav"
      sx={(theme: Theme) => ({
        [theme.breakpoints.up(1400)]: {
          width: drawerWidth,
          flexShrink: 0
        },
      })}
      aria-label="Side menu"
    >
      {/* Mobile Drawer start */}
      <Drawer
        variant="temporary"
        open={isMobileDrawerOpen}
        onClose={handleMobileDrawerClose}
        anchor="left"
        ModalProps={{
          keepMounted: true,
        }}
        PaperProps={{
          role: 'dialog',
          'aria-modal': true,
          'aria-label': 'Main navigation drawer opened',
        }}
        sx={(theme: Theme) => ({
          display: {
            xs: 'block',
          },
          [theme.breakpoints.up(1400)]: {
            display: "none"
          },
          '& .MuiDrawer-paper': {
            boxSizing: 'border-box',
            width: drawerWidth,
          },
        })}>
        <CommonLayoutDrawer handleMobileDrawerClose={handleMobileDrawerClose} />
      </Drawer>
      {/* Mobile Drawer end */}

      {/* Big Screen Drawer start */}
      <Drawer
        variant="permanent"
        sx={(theme: Theme) => ({
          display: {
            md: 'block'
          },
          [theme.breakpoints.down(1400)]: {
            display: "none"
          },
          '& .MuiDrawer-paper': {
            boxSizing: 'border-box',
            width: drawerWidth,
            border: 0,
            minHeight: '100vh',
            overflow: 'auto',
          },
          '& .MuiDrawer-paper::-webkit-scrollbar': {
            width: '5px',
          },
          '& .MuiDrawer-paper::-webkit-scrollbar-thumb': {
            backgroundColor: `${theme.palette.common.black}80`,
            borderRadius: '10px',
          },
        })}
        open>
        <CommonLayoutDrawer handleMobileDrawerClose={handleMobileDrawerClose} />
      </Drawer>
      {/* Big Screen Drawer end */}
    </Box>
  );
};

export function CommonLayout({ children }: { children: JSX.Element }): JSX.Element {
  const [isMobileDrawerOpen, setMobileDrawerOpen] = useState(false);

  const handleMobileDrawerOpen = () => {
    setMobileDrawerOpen(true)
  }

  const handleMobileDrawerClose = () => {
    setMobileDrawerOpen(false);
  };

  const handleMobileDrawerToggle = () => {
    setMobileDrawerOpen(prevState => !prevState);
  };

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          width: '100%'
        }}
      >
        <CommonLayoutSidenav
          isMobileDrawerOpen={isMobileDrawerOpen}
          handleMobileDrawerClose={handleMobileDrawerClose}
        />
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            flexGrow: 1,
            minWidth: 0,
          }}
        >
          <Header handleDrawerOpen={handleMobileDrawerOpen} />
          <Box
            component="main"
            sx={(theme: Theme) => ({
              ml: { xs: 0, md: 0 },
              p: { xs: '0 25px 25px 25px' },
              borderRadius: '50px 0 0 0',
              bgcolor: { xs: '' },
              [theme.breakpoints.down(1400)]: {
                bgcolor: theme.palette.background.default
              },
            })}
          >
            <Container
              maxWidth={false}
              disableGutters={true}
            >
              {children}
            </Container>
          </Box>
        </Box>
      </Box>
    </>
  );
};

export function getAbbreviatedName(fullName: string): JSX.Element {
  const abbreviatedName = getAbbreviatedCharactors(fullName);

  return (
    <Box
      aria-hidden="true"
      sx={{
        backgroundColor: 'primary.50',
        border: '1px solid',
        borderColor: 'primary.200',
        borderRadius: '50%',
        width: '58px',
        height: '58px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
      }}
    >
      <Typography
        variant="h1"
        sx={{
          fontSize: '24px',
          fontWeight: 700,
          letterSpacing: '0.02px',
          lineHeight: 1,
          color: 'primary.800',
        }}
      >
        {abbreviatedName}
      </Typography>
    </Box>
  );
}
